import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

export class MetaDataHelper {
  static getMetaData(key) {
    switch (key) {
      case 'home':
        return {
          descr: 'ZEPNURhealth is a tech platform that assists small to mid-sized medical and dental facilities, efficiently procure and manage their medical equipment and consumables. By streamlining offline and online efforts, employing a team of trained biomedical engineers, and maintaining strong relationships with industry leaders in the medical and dental space, ZEPNURhealth is able to offer a comprehensive tech solution that can help medical facilities curb their expenses and manage their equipment and purchases.',
          title: 'Your medical procurement consultant from enquiry to installation',
          searchable: 'oxygen concentrator, dental products online, medical equipment online, best dental chair, thermocoagulator, new hospital setup, gnatus dental chair, dental rvg, bpl ecg machine 3 channel, 3m 9004in masks, refurbished medical equipment, new dental clinic, RMS, Vatech, Allengers, Trivitron Healthcare, patient monitors, ecg machines, woodpecker infrared thermometer, dental autoclave, autoclave price, BPL, hospital medical equipment suppliers, hospital procurement, best healthcare consulting firms, business consultant healthcare, global, healthcare consulting, consultant hospital, healthcare innovation consulting, hospital consulting companies, hospital consultancy, hospital consultancy in India, hospital consultancy services, hospital consultancy services in india'
        }
      default:
        return {
          descr: 'ZEPNURhealth is a tech platform that assists small to mid-sized medical and dental facilities, efficiently procure and manage their medical equipment and consumables. By streamlining offline and online efforts, employing a team of trained biomedical engineers, and maintaining strong relationships with industry leaders in the medical and dental space, ZEPNURhealth is able to offer a comprehensive tech solution that can help medical facilities curb their expenses and manage their equipment and purchases.',
          searchable: 'medical equipments, medical procurement',
          title: 'Your medical procurement consultant from enquiry to installation'
        }
    }
  }

  static processMetaData = (page, data) => {
    const defaultMetadata = MetaDataHelper.getMetaData(page)
    const metaData = data || {}

    if (!metaData.title) {
      metaData.title = defaultMetadata.title
    }
    if (!metaData.searchable) {
      metaData.searchable = defaultMetadata.searchable
    }
    if (!metaData.descr) {
      metaData.descr = defaultMetadata.descr
    }
    return {
      title: metaData.title,
      description: metaData.descr,
      keywords: metaData.searchable
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/helpers/MetaDataHelper.js